import { Button, ButtonStyles, Icons, SelectList } from '@silverfort/sf-components';
import { FC, useMemo } from 'react';
import { useActiveDirectoryAccessContext } from '../../../context';

interface ResourcesOptionsMenuProps {
    onStaleSettingsUpdateClick: () => void;
}

export const ResourcesOptionsMenu: FC<ResourcesOptionsMenuProps> = ({ onStaleSettingsUpdateClick }) => {
    const { hasAccessIntelligenceEditorRole } = useActiveDirectoryAccessContext();

    const menuItems = useMemo(
        () => [
            {
                disabled: !hasAccessIntelligenceEditorRole,
                onClick: onStaleSettingsUpdateClick,
                title: 'Stale access setting'
            }
        ],
        [hasAccessIntelligenceEditorRole, onStaleSettingsUpdateClick]
    );

    return (
        <div className={`flex h-full flex-shrink-0 items-center justify-center`}>
            <SelectList
                items={menuItems}
                menuProps={{
                    anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
                    transformOrigin: { vertical: 'top', horizontal: 'right' }
                }}
                triggerProps={{
                    buttonStyle: ButtonStyles.Primary,
                    iconLeft: Icons.MoreVertical,
                    iconSize: 16
                }}
                TriggerComponent={Button}
            />
        </div>
    );
};
